// Module
var code = `<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="navy_event.NavyEventMultipliersSpendChart"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="navy_event.NavyEventMissionStartChart"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="navy_event.NavyEventMissionEndChart"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="navy_event.NavyEventMissionFewEndChart"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="navy_event.NavyEventMissionLevelsChart"></bfg-chart>
    </div>
</div>
`;
// Exports
module.exports = code;